export default __webpack_public_path__ + "static/amazonFires5-503175282c8f46f708f09a64a5184dc0.gif";